/**
 * ReportSubscribersActivity entity class
 */

import moment from 'moment'

/**
 * ReportSubscribersActivityFactory
 * returns ReportSubscribersActivity entity class
 *
 * @class ReportSubscribersActivityFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportSubscribersActivity} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportSubscribersActivityFactory
 */
/* @ngInject */
export default function ReportSubscriberActivityFactory (Report) {
  /* === ReportSubscribers class === */

  /**
   * ReportSubscribersActivity model
   *
   * @class ReportSubscribers
   * @classdesc ReportSubscribersActivity model
   * @memberof models
   * @see models
   * @extends models.Report
   * @return {models.ReportSubscribersActivity} ReportSubscribersActivity entity
   */
  function ReportSubscribersActivity () {
    var obj = Report.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportSubscribersActivity.prototype = Object.create(Report.prototype)
  ReportSubscribersActivity.prototype.constructor = ReportSubscribersActivity

  /* === User instance methods & fields === */

  Object.assign(ReportSubscribersActivity.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Report#
     * @type {Object}
     */
    _fields: {
      id: Number,
      deleted: Number,
      name: String,
      status: String,
      creationTime: String,
      startDate: Number,
      endDate: Number,
      networks: [],
      creator: String
    },

    /**
     * Prepare object
     *
     * @memberof models.ReportSubscribersActivity#
     * @override
     */
    _prepare () {
      const x = new Date()
      const currentTimeZoneOffsetInHours = x.getTimezoneOffset() / 60
      this.creationTime = moment(this.creationTime).utc().subtract(+currentTimeZoneOffsetInHours, 'hours').format('MM/DD/YYYY H:m')
    },

    /**
     * url template
     *
     * @memberof models.ReportSubscribersActivity#
     * @type {String}
     */
    _urlTemplate: 'api/reports/subscriberactivity/{{::id}}'

  })

  /* === User static methods & fields === */

  // copy all static methods from ReportSubscribersActivity class
  Object.assign(ReportSubscribersActivity, Report)
  ReportSubscribersActivity._name = 'ReportSubscribersActivity'
  ReportSubscribersActivity.init()

  // permissions
  // ReportSubscribersActivity.access = {
  //   view: 'viewReport',
  //   delete: 'deleteReport'
  // }

  return ReportSubscribersActivity
}
